import { render } from "./information.vue?vue&type=template&id=d68add42&scoped=true"
import script from "./information.vue?vue&type=script&lang=js"
export * from "./information.vue?vue&type=script&lang=js"

import "./information.vue?vue&type=style&index=0&id=d68add42&lang=css"
import "./information.vue?vue&type=style&index=1&id=d68add42&lang=scss&scoped=true"
import "./information.vue?vue&type=style&index=2&id=d68add42&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/edu-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d68add42"]])

export default __exports__